import React from "react";
import { Scatter } from "react-chartjs-2";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

const chartData = {
  labels: ["Scatter"],
  datasets: [
    {
      label: "Scatter",
      fill: false,
      backgroundColor: colors.ReactifyChartColor1,
      pointBorderColor: colors.ReactifyChartColor1,
      pointBackgroundColor: "#fff",
      pointBorderWidth: 5,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: colors.ReactifyChartColor1,
      pointHoverBorderColor: colors.ReactifyChartColor1,
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [
        { x: 65, y: 75 },
        { x: 59, y: 49 },
        { x: 80, y: 90 },
        { x: 81, y: 29 },
        { x: 56, y: 36 },
        { x: 55, y: 25 },
        { x: 40, y: 18 }
      ]
    }
  ]
};

function ScatterChart() {
  return (
    <div>
      <Scatter data={chartData} />
    </div>
  );
}

export default ScatterChart;
